import { CONFIGURACION_MEMBRESIAS, CONFIGURACION_REGIMENES_FISCALES, CONFIGURACION_GIROS } from '../actions/types';

const initialState = {
    membresias: {
        listado: [],
        detalles: null
    }, 
    regimenes_fiscales: {
        listado: []
    },
    giros: {
        listado: []
    },
};

export default (state = initialState, action) => {

    const { type, payload } = action;

    switch ( type ) {
        case CONFIGURACION_MEMBRESIAS.BUSCAR:
            return {
                ...state,
                membresias: {
                    ...state.membresias, 
                    listado: payload
                }
            };

        case CONFIGURACION_MEMBRESIAS.AGREGAR:
            let membresias_agregar = state.membresias.listado;

            membresias_agregar = [
                ...membresias_agregar, payload
            ];

            membresias_agregar.sort(function (a, b) {
                if (a.nombre > b.nombre) {
                    return 1;
                }
                if (a.nombre < b.nombre) {
                    return -1;
                }
                return 0;
            });

            return {
                ...state, 
                membresias: {
                    ...state.membresias, 
                    listado: membresias_agregar
                }
            };

        case CONFIGURACION_MEMBRESIAS.DETALLES:
            return {
                ...state,
                membresias: {
                    ...state.membresias, 
                    detalles: payload
                }
            };

        case CONFIGURACION_MEMBRESIAS.EDITAR:
            let membresias_editar = state.membresias.listado;

            membresias_editar = membresias_editar.map(membresia => membresia._id === payload._id ? payload : membresia);

            membresias_editar.sort(function (a, b) {
                if (a.nombre > b.nombre) {
                    return 1;
                }
                if (a.nombre < b.nombre) {
                    return -1;
                }
                return 0;
            });

            return {
                ...state, 
                membresias: {
                    ...state.membresias, 
                    listado: membresias_editar
                }
            };

        case CONFIGURACION_MEMBRESIAS.ELIMINAR:
            return {
                ...state, 
                membresias: {
                    ...state.membresias, 
                    listado: state.membresias.listado.filter( membresia => membresia._id !== payload.id )
                }
            };
        
        case CONFIGURACION_REGIMENES_FISCALES.BUSCAR:
            return {
                ...state,
                regimenes_fiscales: {
                    ...state.regimenes_fiscales, 
                    listado: payload
                }
            };

        case CONFIGURACION_GIROS.BUSCAR:
            return {
                ...state,
                giros: {
                    ...state.giros, 
                    listado: payload
                }
            };
    
        default:
            return state;
    }
}